'use strict';

const Validation = require('../../../common/frontend/helpers/validation')(
  document
);

module.exports = ({
  form,
  recaptchaId,
  validationConfigs,
  shouldUseRecaptcha,
  onSubmit,
}) => {
  if (
    validationConfigs.every(({ element, config }) =>
      Validation.validate(element, config, window.I18n)
    )
  ) {
    if (shouldUseRecaptcha && window.grecaptcha && window.grecaptcha.execute) {
      window.grecaptcha.execute(recaptchaId);
    } else {
      if (onSubmit) {
        onSubmit(form);
      } else {
        form.submit();
      }
    }
  }
};
